import { request as get } from './reducers/get';
import { request as multiple } from './reducers/multiple';
import * as alerts from './reducers/alerts';
import * as multiples from './reducers/multiples';
import * as avgNetPayout from './reducers/avg-net-payout';
import * as lastLegRums from './reducers/last-legs-rum';

import * as multiplesDetails from './reducers/multiples-line-details';

// eslint-disable-next-line import/no-default-export
export default {
    MARKETS_GET_LIABILITIES_REQUEST: get,
    MARKETS_GET_MULTIPLE_LIABILITIES_REQUEST: multiple,

    GET_LIABILITY_ALERTS: alerts.request,
    GET_MULTIPLES: multiples.request,

    GET_AVG_NET_PAYOUTS: avgNetPayout.request,
    GET_LEGS_RUM: lastLegRums.request,

    GET_MULTIPLES_LINE_DETAILS: multiplesDetails.request,
};
